<div class="container p-0" style="position:relative">
  <ngx-spinner name="load" [fullScreen]="false" type="timer"></ngx-spinner>
  <ul class="nav nav-tabs mt-2">
    <li class="nav-item">
      <span class="nav-link " [class.active]="tab=='user'" (click)="tab='user'">مدیریت صفحات</span>
    </li>
    <li class="nav-item">
      <span class="nav-link " [class.active]="tab=='image'" (click)="tab='image'">تایید با تصاویر</span>
    </li>
  </ul>

  <section class="tab-content">
    <app-index *ngIf="tab=='user'" type="Instagram"></app-index>

    <section *ngIf="tab=='image'" class="row">
      <div class="col-3 border-left p-1">
        <div class="container-capped-xs p-0">
          <!-- <div class="btn btn-blue fs-sm" type="button" (click)="refine()">آرشیو آگهی های حذف شده از اینستاگرام</div> -->
          <div *ngFor="let key of Object.keys(users);let index=index" dir="ltr"
            class="my-1 p-1 pointer rounded-xl shadow-kp border-dark-gray d-flex justify-content-between"
            [class.border]="user==key" [class.bg-success]="trusteds.includes(key.replace('@',''))">
            <div class="m-1">[{{users[key]|number}}]</div>
            <i class="fa fa-user-times f-red fs-xl mx-2 pointer" (click)="saveIndex(key,'BLOCKED')"
              title="بلاک دائم این صفحه"></i>
            <i class="fa fa-user-check f-green fs-xl mx-2 pointer" *ngIf="!trusteds.includes(key.replace('@',''))"
              (click)="saveIndex(key,'TRUSTED')" title="این صفحه مناسب است"></i>
            <h6 class="flex-grow-1 m-1" (click)="load(key)">{{key}}</h6>
            <div class="m-1">.{{index+1}}</div>
          </div>
        </div>

      </div>
      <div class="col-8 ">
        <a class="link mx-1 p-a" target="_blank" [queryParams]="{status:4,sourcetype:3,sort:3}"
          [routerLink]="['/admin','ads']">اشتباهی تایید شد؟</a>
        <a class="link mx-1 p-a" target="_blank" [queryParams]="{status:3,sourcetype:3,sort:3}"
          [routerLink]="['/admin','ads']">اشتباهی مرجوع شد؟</a>

        <div class="d-flex justify-content-between align-items-center p-1">
          <label>
            <input type="search" [(ngModel)]="keyword" (debounce)="load()">
          </label>
          <div *ngIf="keyword && criteria?.Keyword && jobs?.length" class="pointer btn" (confirm)="rejectAll()">
            <i class="fa fa-times f-red fs-xl mx-2"></i>
            حذف همه‌ی جستجو شده‌ها
          </div>
          <app-pagination [total]="total" (page)="load($event)" [limit]="limit"></app-pagination>
        </div>
        <div class="row">
          <div *ngFor="let job of jobs;let i=index;trackBy:trackByFn" class="col-12 pb-2 mb-2 border-bottom">
            <i class="fa fa-times f-red fs-xl mx-2 pointer" (click)="setStatus(job.Id, JobStatus.Rejected, i)"></i>
            <i class="fa fa-check f-green fs-xl mx-2 pointer" (click)="setStatus(job.Id, JobStatus.Started, i)"></i>
            <i class="fa fa-star f-blue fs-xl mx-2 pointer"
              (contextmenu)="setStatus(job.Id, JobStatus.Rejected, i, $event)"
              (click)="setStatus(job.Id, JobStatus.Started, i)" title="کلیک راست مرجوع | کلیک چپ تایید"></i>
            <div class="row h-100 overflow-auto">
              <div class="col-12 col-md-6 ">
                <div [innerHTML]="(job.Description || job.Title)"></div>
                <div>
                  <i class="fa fa-user-times f-red fs-xl mx-2 pointer" (click)="saveIndex(job.SourceName,'BLOCKED')"
                    title="بلاک دائم این صفحه"></i>
                  <i class="fa fa-user-check f-green fs-xl mx-2 pointer" (click)="saveIndex(job.SourceName,'TRUSTED')"
                    title="این صفحه مناسب است"></i>
                  <i class="fa fa-user-tag f-blue fs-xl mx-2 pointer" (click)="load(job.SourceName)"
                    title="نمایش آگهی های این صفحه"></i>
                </div>
                <div class="form-group clearfix">
                  <div>شهر:</div>
                  <app-location name="location" accept-level="Globe" [(ngModel)]="jobs[i]"></app-location>
                </div>
              </div>
              <div class="col p-0">
                <iframe [src]="(job.SourceUrl + 'embed') | bypassSanitizeUrl" width="350" height="470"
                  frameborder="0"></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>


    </section>

  </section>
</div>